import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { pdfStylesV2, divisorV2, PDF_COLORS, PDF_PAGE_MARGINS, pdfFz, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFItemsTableV2, PDFItemImagesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFBrandFooterConNumeroV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { formatearDireccionEntrega } from "../../Components/PdfComponents/formatearDireccionEntrega";
import { BloqueFirmasPdf } from "../../Components/PdfComponents/BloqueFirmasPdf";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");


const pedidoPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || values.quitarImpuestos || false;
  const ocultarColumnaIVA = empresa?.ocultarColumnaIVA || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  const dataSat = values.respuestaFactura.dataSat;
  const direccionEntrega = values.respuestaFactura?.dataSat?.direccionEntrega || null;
  let agregarImpDesc = 0;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const mostrarTipoComprobante = !empresa?.deshabilitarTipoComprobantePdf;
  const mostrarMoneda = !empresa?.deshabilitarMonedaPdf;
  const mostrarLugarExpedicion = !empresa?.deshabilitarLugarExpedicionPdf;
  const mostrarCondicionesPago = !empresa?.deshabilitarCondicionesPagoPdf;
  const mostrarMetodoPago = !empresa?.deshabilitarMetodoPagoPdf;
  const mostrarOC = !empresa?.deshabilitarOCPdf;
  const mostrarFecha = !empresa?.deshabilitarFechaPdf;
  const mostrarFechaEntrega = !empresa?.deshabilitarFechaEntregaPdf;
  const ocultarColumnaPU = !!empresa?.ocultarColumnaPU && !dataSat?.mostrarPrecio;
  const ocultarColumnaImporte = !!empresa?.ocultarColumnaImporte && !dataSat?.mostrarPrecio;
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true && !ocultarColumnaPU;
  const widthPUConDescuento = 9;
  const mostrarCuadroTotales = !empresa?.ocultarCuadroTotalesPdf || !!dataSat?.mostrarTotales;
  const { referencia: referenciaEntrega, direccion: direccionEntregaTexto } = formatearDireccionEntrega(
    direccionEntrega,
    { mostrarReferencia: !!empresa?.mostrarReferenciaEntregaPdf }
  );
  // Texto, no arreglo: kvRows esparce cualquier objeto como nodo y con [] la celda queda sin
  // `text` (pdfmake: "Unrecognized document structure"). Las respuestas de agregarVenta,
  // generarFactura, etc. no traen `proyecto`; solo obtenerRespuestaFactura lo arma.
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || "";
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  const esDataUrlValida = (s) =>
    typeof s === "string" &&
    /^data:(image|application)\/[a-zA-Z0-9.+-]+;base64,/.test(s);

  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot;
  const mostrarClave = !empresa?.deshabilitarClaveCot;

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 8;
  const widthIVA = 8;
  const widthPU = quitarImpuestosRemisiones ? 15 : 10.5;
  const widthImporte = quitarImpuestosRemisiones ? 15 : 12.5;

  let widthExtraDescripcion = 0;
  if (!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if (!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !empresa.imprimirIEPS) {
    widthExtraDescripcion += widthIEPS;
  }
  if (!quitarImpuestosRemisiones && ocultarColumnaIVA) {
    widthExtraDescripcion += widthIVA;
  }
  if (ocultarColumnaPU) widthExtraDescripcion += widthPU;
  if (ocultarColumnaImporte) widthExtraDescripcion += widthImporte;

  const widthExtraCantidad = Math.round(widthExtraDescripcion * 0.05 * 10) / 10;
  const widthExtraUnidad = Math.round(widthExtraDescripcion * 0.15 * 10) / 10;
  const widthExtraClave = mostrarClave ? Math.round(widthExtraDescripcion * 0.15 * 10) / 10 : 0;
  const widthExtraDescripcionFinal = Math.round((widthExtraDescripcion - widthExtraCantidad - widthExtraUnidad - widthExtraClave) * 10) / 10;

  const conceptos = dataSat.Conceptos.map((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    let relacionDescuento = Number(valueConcepto.Descuento) / Number(valueConcepto.Importe);
    valueConcepto.Impuestos?.Traslados?.map((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
      return null;
    });
    agregarImpDesc += agregarImpConcepto;
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const precioUnitarioNeto = quitarImpuestosRemisiones
      ? (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1)
      : Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1);

    const imagenesEntrada = Array.isArray(valueConcepto.imagenes) ? valueConcepto.imagenes : [];
    const imagenesBase64 = imagenesEntrada
      .map((img) => (typeof img === "string" ? img : img?.base64Completa))
      .filter(esDataUrlValida);

    const celdaCantidad = { style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right" };
    return [
      { style: "textoTablaChico", text: index + 1, alignment: "center" },
      ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidad]),
      {
        text: (() => {
          const textoUnidad = (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad;
          return valueConcepto.presentacionCliente || textoUnidad;
        })(),
        style: "textoTablaChico",
        alignment: "center",
      },
      ...(mostrarClaveSAT ? [{ text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center" }] : []),
      ...(mostrarClave ? [{ text: valueConcepto.NoIdentificacion, style: "textoTablaChico", alignment: "center" }] : []),
      (() => {
        const textoDescSinObs =
          valueConcepto.Descripcion +
          (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
          (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
          (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
        const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
        const extras = [];
        if (Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0) {
          extras.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
        }
        if (Array.isArray(valueConcepto.ComponentesKit) && valueConcepto.ComponentesKit.length > 0) {
          extras.push({ text: "Incluye: " + valueConcepto.ComponentesKit.map(c => `${c.descripcion} (x${c.cantidad})`).join(", "), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
        }
        const imgsNode = PDFItemImagesV2(imagenesBase64);
        if (imgsNode) extras.push(imgsNode);
        if (valueConcepto.DescripcionLarga) {
          // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
          return {
            stack: [
              { text: textoDescSinObs, style: "textoTablaChico" },
              { text: valueConcepto.DescripcionLarga, fontSize: pdfFz(5), color: "#555", margin: [0, 1, 0, 0] },
              ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico" }] : []),
              ...extras,
            ],
            alignment: "left",
          };
        }
        if (extras.length) {
          return { stack: [{ text: textoDesc, style: "textoTablaChico" }, ...extras], alignment: "left" };
        }
        return { text: textoDesc, style: "textoTablaChico", alignment: "left" };
      })(),
      ...(cantidadJuntoPrecioUnitario ? [celdaCantidad] : []),
      ...(ocultarColumnaPU ? [] : [{
        stack: [
          {
            text: dineroDisabledMask(
              quitarImpuestosRemisiones
                ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
                : valueConcepto.ValorUnitario,
              decimalesPrecioUnitarioPdf
            ),
            style: "textoTablaChico", alignment: "right",
          },
          ...(
            !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [{
                columns: [
                  { text: round2Decimals((Number(valueConcepto.Descuento) * 100) / (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))) + "%:", width: "*", alignment: "left", style: "descuentoPartida", noWrap: true },
                  { text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento / (Number(valueConcepto.Cantidad || 1)))), width: "auto", alignment: "right", style: "descuentoPartida", noWrap: true },
                ],
                columnGap: 8, margin: [0, 2, 0, 0],
              }]
              : []
          )
        ]
      }]),
      ...(precioUnitarioConDescuento ? [{ text: dineroDisabledMask(precioUnitarioNeto, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "right" }] : []),
      ...(quitarImpuestosRemisiones ? [] : [
        ...(ocultarColumnaIVA ? [] : [{ text: dineroDisabledMask(quitarImpuestosRemisiones ? 0 : iva), style: "textoTablaChico", alignment: "right" }]),
        ...(empresa.imprimirIEPS ? [{ text: dineroDisabledMask(ieps), style: "textoTablaChico", alignment: "right" }] : []),
      ]),
      ...(ocultarColumnaImporte ? [] : [{
        stack: [
          {
            text: dineroDisabledMask(
              quitarImpuestosRemisiones
                ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
                : valueConcepto.Importe
            ),
            style: "textoTablaChico", alignment: "right",
          },
          ...(
            !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [{ text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)), style: "descuentoPartida", alignment: "right", margin: [0, 2, 0, 0] }]
              : []
          )
        ]
      }]),
    ];
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["implocal:TrasladosLocales"] || [])]
    : [...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["implocal:TrasladosLocales"] || [])];

  let totalImpuestos = 0;

  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002" ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%` : a.Impuesto === "003" ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%` : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002" ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%` : b.Impuesto === "003" ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%` : b["@ImpLocTrasladado"];
    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") nombre = "IVA";
    else if (valueImpuesto.Impuesto === "003") nombre = "IEPS";
    else nombre = valueImpuesto["@ImpLocTrasladado"];
    if (valueImpuesto.TipoFactor === "Tasa") nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    else if (valueImpuesto.TipoFactor === "Cuota") nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
    totalImpuestos += valueImpuesto.Importe || valueImpuesto["@Importe"];
    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["implocal:RetencionesLocales"] || [])]
    : [...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["implocal:RetencionesLocales"] || [])];

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") nombre = nombre + "ISR";
    else if (valueRetencion.Impuesto === "002") nombre = nombre + "IVA";
    else nombre = valueRetencion["@ImpLocRetenido"];
    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["@TotaldeTraslados"] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["@TotaldeRetenciones"] || 0) || 0;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: "CANCELADO", color: "GRAY", opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  } else if (values.esPreview) {
    cancelado = { watermark: { text: 'VISTA PREVIA', color: '#1677ff', opacity: 0.15, bold: true, italics: false, angle: -50, fontSize: 90 } };
  }

  const mostrarBancos = !dataSat?.deshabilitarBanco;
  const filasBanco1 = [
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;
  const vendedorVar = empresa.vendedorVentas && values.vendedor ? values.vendedor : null;

  // --- Tabla de conceptos: encabezado + anchos (mismos del clásico) ---
  const title = [
    { text: "", style: "tituloTabla" },
    ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
    { text: "Unidad", style: "tituloTabla" },
    ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
    ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
    { text: "Descripción", style: "tituloTabla" },
    ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
    ...(ocultarColumnaPU ? [] : [{ text: "P/U", style: "tituloTabla" }]),
    ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
    ...(quitarImpuestosRemisiones ? [] : [
      ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
      ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
    ]),
    ...(ocultarColumnaImporte ? [] : [{ text: "Importe", style: "tituloTabla" }]),
  ];

  const widths = quitarImpuestosRemisiones
    ? [
      "2%",
      ...(cantidadJuntoPrecioUnitario ? [] : [`${7 + widthExtraCantidad}%`]),
      `${8 + widthExtraUnidad}%`,
      ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
      ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
      `${36 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
      ...(cantidadJuntoPrecioUnitario ? [`${7 + widthExtraCantidad}%`] : []),
      ...(ocultarColumnaPU ? [] : ["15%"]),
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
      ...(ocultarColumnaImporte ? [] : ["15%"]),
    ]
    : [
      "2%",
      ...(cantidadJuntoPrecioUnitario ? [] : [`${4 + widthExtraCantidad}%`]),
      `${6 + widthExtraUnidad}%`,
      ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
      ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
      `${28 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
      ...(cantidadJuntoPrecioUnitario ? [`${4 + widthExtraCantidad}%`] : []),
      ...(ocultarColumnaPU ? [] : ["10.5%"]),
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
      ...(ocultarColumnaIVA ? [] : ["8%"]),
      ...(empresa.imprimirIEPS ? ["8%"] : []),
      ...(ocultarColumnaImporte ? [] : ["12.5%"]),
    ];

  // --- Metadata del encabezado (columna derecha) ---
  const headerMeta = [
    { label: "N° Pedido:", value: (dataSat.Serie ? dataSat.Serie : "P") + " - " + dataSat.Folio },
    ...(mostrarMoneda ? [{ label: "Moneda:", value: dataSat.Moneda }] : []),
    ...(mostrarLugarExpedicion ? [{ label: "Lugar de expedición:", value: dataSat.LugarExpedicion }] : []),
    ...(mostrarOC ? [{ label: "Orden de compra:", value: dataSat.pedido }] : []),
    ...(dataSat.req ? [{ label: "Req:", value: dataSat.req }] : []),
    ...(mostrarCondicionesPago ? [{
      label: "Condiciones de pago:",
      value: dataSat.condicion === 1 ? "Contado" : "Crédito (" + (dataSat?.Receptor?.diasCredito ? dataSat?.Receptor?.diasCredito : "0") + " días)",
    }] : []),
    ...(vendedorVar ? [{ label: "Vendedor:", value: vendedorVar.nombre + (vendedorVar.apellidoPaterno ? " " + vendedorVar.apellidoPaterno : "") + (vendedorVar.apellidoMaterno ? " " + vendedorVar.apellidoMaterno : "") }] : []),
  ];

  // --- Datos cliente / proyecto ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.Nombre, strong: true },
    ...(dataSat?.Receptor?.codigoProveedor ? [{ label: "Código Proveedor:", value: dataSat.Receptor.codigoProveedor }] : []),
    ...(mostrarFecha ? [{ label: "Fecha:", value: moment(dataSat.Fecha).locale("es").format("LL") }] : []),
    ...(mostrarMetodoPago ? [{ label: "Método de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" }] : []),
  ];

  const clienteRight = [
    ...(empresa?.mostrarProyectoVentas ? [{ label: "Proyecto:", value: proyecto, strong: true }] : []),
    ...(referenciaEntrega ? [{ label: "Referencia:", value: referenciaEntrega }] : []),
    ...(direccionEntrega?.destino ? [{ label: "Destino:", value: direccionEntrega?.destino }] : []),
    ...(direccionEntrega?.embarque ? [{ label: "Embarque:", value: direccionEntrega?.embarque }] : []),
    ...(direccionEntregaTexto ? [{ label: "Dirección de Entrega:", value: direccionEntregaTexto }] : []),
    ...(mostrarFechaEntrega && dataSat.fechaEntregaEstimada ? [{ label: "Fecha de entrega estimada:", value: moment(dataSat.fechaEntregaEstimada).locale("es").format("LL") }] : []),
    ...(dataSat?.atencion ? [{ label: "Atención a:", value: dataSat.atencion }] : []),
  ];

  // --- Cierre: importe con letra + datos bancarios (izquierda) ---
  const bancosRows = mostrarBancos ? [...filasBanco1] : [];
  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };
  const cierreIzquierda = {
    stack: [
      ...(mostrarCuadroTotales ? [importeLetra] : []),
      ...(bancosRows.length ? [PDFPaymentInfoV2({ titulo: "Datos bancarios", rows: bancosRows })] : []),
    ],
  };

  // --- Filas de totales (derecha) ---
  const totalsRows = [
    {
      label: "Subtotal:",
      value: dineroDisabledMask(quitarImpuestosRemisiones ? dataSat.SubTotal + totalImpuestos + agregarImpDesc : dataSat.SubTotal),
    },
    ...(((quitarImpuestosRemisiones ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento) > 0)
      ? [{
        label: "Descuento:",
        value: "- " + dineroDisabledMask(quitarImpuestosRemisiones ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento),
      }]
      : []),
    ...(quitarImpuestosRemisiones ? [] : impuestosTotales),
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  const dd = {
    ...cancelado,
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Pedido",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "P") + " - " + dataSat.Folio,
        regimenFiscal: mostrarRegimen,
        tipoComprobante: mostrarTipoComprobante ? "ingreso" : false,
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 6, 1),
      PDFItemsTableV2({ title, conceptos, widths }),
      PDFSummarySectionV2({ left: cierreIzquierda, rows: mostrarCuadroTotales ? totalsRows : [] }),
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      ...(empresa.textoAdicionalPedidosCotizaciones
        ? [
          divisorV2(PDF_COLORS.neutralDivider, 6, 1),
          { text: empresa.textoAdicionalPedidosCotizaciones, style: "textoAdicionalPedidosCotizaciones", margin: [0, 2, 0, 0] },
        ]
        : []),
      ...(empresa?.camposFirmaVentas
        ? [BloqueFirmasPdf([{ titulo: "Entregó" }, { titulo: "Recibió" }])]
        : []),
    ],
    footer: PDFBrandFooterConNumeroV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  return dd;
};

export default pedidoPdfV2;
